import { ReactElement, useState } from 'react'
import { isEmpty } from 'lodash'

import { initNewServicesForm } from 'models/services'
import { useLogin } from 'features/Login/hooks'
import { RouteForm } from './RouteForm'
import { ItineraryAndVehicleForm } from './ItineraryAndVehicleForm'
import { INewServicesForm } from 'features/Services/components/NewServicesV2/types'
import { INewTripProps } from 'features/Trips/components/NewTrip/types'
import { canSelectCompany } from 'features/Login/utils'

export const NewTrip = ({ loading, error, onSubmit }: INewTripProps): ReactElement => {
  const login = useLogin()
  const [step, setStep] = useState(1)
  const [serviceForm, setServiceForm] = useState<INewServicesForm>(
    initNewServicesForm(canSelectCompany(login.accessToken) ? undefined : login.accessToken.companyIds[0])
  )

  const handleCancel = (partialService?: Partial<INewServicesForm>): void => {
    if (!isEmpty(partialService)) {
      setServiceForm({
        ...serviceForm,
        ...partialService
      })
    }
    setStep(step - 1)
  }

  const handleSubmit = (partialService: Partial<INewServicesForm>): void => {
    setServiceForm({
      ...serviceForm,
      ...partialService
    })
    setStep(step + 1)
  }

  const handleCreateTrip = (partialService: Partial<INewServicesForm>): void => {
    onSubmit({ ...serviceForm, ...partialService })
  }

  switch (step) {
    case 1:
      return <RouteForm service={serviceForm} onSubmit={handleSubmit} />
    case 2:
      return (
        <ItineraryAndVehicleForm
          service={serviceForm}
          onCancel={handleCancel}
          onSubmit={handleCreateTrip}
          loading={loading}
          error={error}
        />
      )
    default:
      return <></>
  }
}
